import React, { useState } from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle, faChevronUp, faChevronDown } from "@fortawesome/free-solid-svg-icons";

const NotesAccordion = ({ estimateData }) => {
  const [warningsOpen, setWarningsOpen] = useState(false);

  if (!estimateData?.warnings || estimateData.warnings.length === 0) {
    return null;
  }

  return (
    <div className="mt-4 bg-orange-50 border border-orange-200 rounded-xl overflow-hidden">
      <button
        onClick={() => setWarningsOpen(!warningsOpen)}
        className="w-full px-4 py-3 flex items-center justify-between text-left focus:outline-none hover:bg-orange-100/50 transition-colors"
      >
        <div className="flex items-center gap-3">
          <FontAwesomeIcon icon={faExclamationTriangle} className="text-orange-500" />
          <span className="font-bold text-orange-800 text-sm">
            Important Pricing Notes ({estimateData.warnings.length})
          </span>
        </div>
        <FontAwesomeIcon 
          icon={warningsOpen ? faChevronUp : faChevronDown} 
          className="text-orange-400 text-sm"
        />
      </button>
      
      {warningsOpen && (
        <div className="px-4 pb-4 pt-1 border-t border-orange-100 bg-orange-50/50">
          <ul className="list-disc pl-8 space-y-1.5 mt-2">
            {estimateData.warnings.map((warning, idx) => (
              <li key={idx} className="text-xs text-orange-700 leading-relaxed">
                {warning}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default NotesAccordion;
